var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
var cls = classNames('topic-indicator-chart');
import { get } from 'lodash';
import { classNames } from '@shapeable/utils';
import { CircleTrailBarChart, useEntity, useLang, useLink } from '@shapeable/ui';
export var TopicIndicatorChartDefaultProps = {
  deriveValue: function (iv) {
    return iv.numericValue;
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var ChartStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme.UNIT(0))
});
var TopicLabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SubTopicLabelStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Chart: styled(CircleTrailBarChart)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ChartStyles),
  TopicLabel: styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), TopicLabelStyles),
  SubTopicLabel: styled.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), SubTopicLabelStyles)
};
export var TopicIndicatorChart = function (props) {
  var className = props.className,
    children = props.children,
    indicatorSlug = props.indicatorSlug,
    indicatorDataSetId = props.indicatorDataSetId,
    deriveValue = props.deriveValue,
    upperValue = props.upperValue;
  var entity = useEntity(props.entity);
  var t = useLang();
  var _a = entity.indicatorValues,
    indicatorValues = _a === void 0 ? [] : _a,
    _b = entity.subTopics,
    subTopics = _b === void 0 ? [] : _b,
    color = entity.color,
    name = entity.name,
    path = entity.path;
  var navigate = useLink().navigate;
  if (!indicatorSlug && !indicatorDataSetId) {
    return null;
  }
  var isValueIncluded = function (iv) {
    return get(iv, 'indicator.slug') === indicatorSlug || get(iv, 'indicator.dataSetId') === indicatorDataSetId;
  };
  var chartIndicatorValues = __spreadArray(__spreadArray([], __read(indicatorValues.filter(isValueIncluded).map(function (iv) {
    return __assign(__assign({}, iv), {
      value: deriveValue(iv),
      size: 'large',
      groupName: t("Emerging Topic"),
      label: name,
      color: color && color.value,
      labelFont: 'serif',
      onCircleClick: function () {
        navigate(path);
      },
      onLabelClick: function () {
        navigate(path);
      }
    });
  })), false), __read(subTopics.flatMap(function (subTopic) {
    return subTopic.indicatorValues.filter(isValueIncluded).map(function (iv) {
      return {
        value: deriveValue(iv),
        size: 'default',
        groupName: t("Sub-Fields"),
        label: subTopic.name,
        color: color && color.value,
        labelFont: 'serif',
        onCircleClick: function () {
          navigate(subTopic.path);
        },
        onLabelClick: function () {
          navigate(subTopic.path);
        }
      };
    });
  })), false);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Chart, {
    gridTitle: t('Anticipation Potential'),
    showTicks: false,
    heightSizeMultipliers: {
      default: 3,
      medium: 4,
      large: 2,
      small: 5
    },
    upperValue: upperValue,
    showValues: false,
    showCountupValues: false,
    backgroundColor: "#ECEDEE",
    items: chartIndicatorValues
  }));
};
TopicIndicatorChart.defaultProps = TopicIndicatorChartDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;